/*
 * Motion engine entry point. Replaces the template's original runtime: one call wires
 * every animation module against a scope and returns a cleanup that fully
 * reverts them (used on route changes).
 */
import { gsap, ScrollTrigger, registerGsap } from './core'
import { initAccordion } from './accordion'
import { initHero } from './hero'
import { initNavbarScroll } from './navbar-scroll'
import { initPageLoad } from './page-load'
import { initScrollReveal } from './scroll-reveal'
import { initScrollParallax, initMouseParallax } from './parallax'
import { initHover } from './hover'

export const initMotion = (scope: HTMLElement): (() => void) => {
    registerGsap()

    const ctx = gsap.context(() => {}, scope)

    initHero(ctx, scope)
    initPageLoad(ctx, scope)
    initNavbarScroll(ctx, scope)
    initScrollReveal(ctx, scope)
    initScrollParallax(ctx, scope)
    initMouseParallax(ctx, scope)
    initHover(ctx, scope)
    initAccordion(ctx, scope)

    document.documentElement.classList.add('mdl-motion-ready')

    // Let layout settle (fonts/images) before measuring scroll positions.
    requestAnimationFrame(() => ScrollTrigger.refresh())

    return () => {
        ctx.revert()
    }
}

export { gsap, ScrollTrigger } from './core'
